import { DeliveryRoot as Root } from './DeliveryContext';
import { Content } from './Content';
import { ItemList } from './ItemList';
import { InvalidCallout } from './InvalidCallout';
import { ActionSubmit } from './ActionSubmit';

export const DeliveryModal = {
    Root,
    Content,
    ItemList,
    InvalidCallout,
    ActionSubmit,
};
